export default "/images/4e4087187c28900d69e71bd968005c26.avif";